import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// State
const state = () => ({
  searchQuery: "",
});

// getters
const getters = {
  getSearchQuery: (state) => state.searchQuery,
};

// actions
const actions = {};

// mutations
const mutations = {
  saveSearchQuery(state, payload) {
    state.searchQuery = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
